import { colors } from '@material-ui/core';

export default {
  root: {
    color: colors.grey[400],
    '&$checked': { color: colors.green[600] }
  },
  checked: {}
};
